import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const ProductEvents: AnalyticsBrandSettings = {

  fichaProductoCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'ficha_producto', 'anadir_producto_cesta', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '48', '58', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  fichaProductoCheckoutAnadirProductoCrossCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'ficha_producto', 'anadir_producto_cross_cesta', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['139', '16', '17', '198', '20', '48', '58', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  fichaProductoWishlistAnadirProductoCrossWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_producto', 'anadir_producto_cross_wishlist', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoWishlistAnadirProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_producto', 'anadir_producto_wishlist', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoSocialCompartirRedSocial(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const socialNetwork = `compartir_${componentData.socialNetwork}`;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'social', 'ficha_producto', socialNetwork, partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoWishlistEliminarProductoCrossWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_producto', 'eliminar_producto_cross_wishlist', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoWishlistEliminarProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_producto', 'eliminar_producto_wishlist', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_color', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarColorProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_color_producto_cross', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['139', '20', '48'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_talla', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarLargo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_largo', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['14', '20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarTallaProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_talla_producto_cross', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['139', '20', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoSeleccionarLargoProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'seleccionar_largo_producto_cross', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['14', '20', '139'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoNavegacionVerAnterior(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'navegacion', 'ficha_producto', 'ver_anterior', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '20', '47', '70', '98', '99', '15'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaProductoCatalogoVerBackSoon(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'ver_back_soon', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoVerComingSoon(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'ver_coming_soon', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '58'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoAyudaVerDevolucion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_devolucion', partnumber);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoDisponibilidadEnTiendaVerDisponibilidadEnTienda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'disponibilidad_en_tienda', 'ficha_producto', 'ver_disponibilidad_en_tienda', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoAyudaVerGuiaTallas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_guia_tallas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoAyudaVerGuiaTallasTrueFit(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_guia_tallas_true_fit');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoVerInformacion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_informacion', partnumber
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoVerProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_producto_cross', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '139', '20', '46', '47', '70', '98', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaProductoNavegacionVerSiguiente(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'navegacion', 'ficha_producto', 'ver_siguiente', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '20', '47', '70', '98', '99', '15'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaProductoCatalogoVerVistaRapidaProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_vista_rapida_producto_cross', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '139', '20', '47', '70', '98', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaProductoCatalogoVerZoom(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_zoom', componentData?.imagePosition
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoAyudaAbrirChat(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'abrir_chat');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoVideoPlayVideo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'video', 'ficha_producto', 'play_video', componentData.videoName);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['80'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoCatalogoVerDetallesTecnicos(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_detalles_tecnicos', partnumber
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoAyudaVerEnvio(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_envio', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoAyudaVerContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_contacto');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoAyudaVerComposicion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_composicion', partnumber);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoAyudaVerCuidados(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_cuidados', partnumber);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoVerFotoAuxiliar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'ver_foto_auxiliar', componentData?.imagePosition
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  productosRelacionadosCatalogoVerFotoAuxiliar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'productos_relacionados', 'ver_foto_auxiliar', componentData?.carouselSlide
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaProductoAyudaVerMasInformacion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_producto', 'ver_mas_informacion');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoNavegacionIrWorldwide(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'ficha_producto', 'ir_worldwide', 'tienda');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoEditarProductoPersonalizable(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'editar_producto_personalizable', partnumber
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoVerModeloTallaGrande(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'ver_modelo_talla_grande');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoVerModeloTallaNormal(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'ficha_producto', 'ver_modelo_talla_normal');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoLegalVerPoliticaDePrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'ficha_producto', 'ver_politica_privacidad');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoErrorFormulario(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'error_{formulario}', '{campo}'
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  fichaProductoCatalogoErrorServidorFormulario(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_producto', 'error_servidor_{formulario}', 'cod_{cod_error}-desc_{desc_error}'
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  }

};
